import { createFileRoute, redirect } from '@tanstack/react-router';

import { sessionQueries } from '@/api';
import { RegisterPage } from '@/features/auth/register-page';

export const Route = createFileRoute('/register')({
	/** Автентифікованому реєструватись нема потреби — див. коментар у login.tsx. */
	beforeLoad: async ({ context }) => {
		const session = await context.queryClient.ensureQueryData(sessionQueries.current());
		if (session) throw redirect({ to: '/dashboard' });
	},
	component: RegisterPage,
	staticData: { fullScreen: true },
});
